const common = {
  "leaderboard.list.column.players": "Players",
  "leaderboard.list.column.score": "Score",
  "leaderboard.list.column.rank": "Rank",
  "leaderboard.list.column.rating": "Rating",

  "leaderboard.user-rank-not-available": "You're not ranked yet",
  "leaderboard.table-rank": "Leaderboard · {{ rank }}",
};

const filters = {
  "leaderboard.filters.general": "General",
  "leaderboard.filters.metrics": "Metrics",
  "leaderboard.filters.location": "Location",
  "leaderboard.location.global": "Global",
  "leaderboard.location.country": "My country",
  "leaderboard.location.continent": "My continent",
  "leaderboard.location.missing.title": "Set your location to unlock local rankings",
  "leaderboard.location.missing.description": "Add your country in your profile settings to compare with nearby players.",
  "leaderboard.location.cta": "Edit profile",
  "leaderboard.filters.age": "Age",
  "leaderboard.age-group.all": "All",
  "leaderboard.age-group.u12": "Under 12",
  "leaderboard.age-group.u16": "Under 16",
  "leaderboard.age-group.u21": "Under 21",
  "leaderboard.age-group.senior": "Senior",
  "leaderboard.age-group.missing.title": "Set your birth date to unlock age rankings",
  "leaderboard.age-group.missing.description": "Add your birth date in your profile settings to compare with players in your age group.",
  "leaderboard.age-group.cta": "Edit profile",
  "leaderboard.profile-incomplete.missing.title": "Complete your profile",
  "leaderboard.profile-incomplete.missing.description": "Add your country and birth date to unlock local and age group rankings.",
  "leaderboard.no-results": "No players found for the selected filters",
};

export const leaderboard = {
  ...common,
  ...filters,
};
